import { render } from "./EnrollView.vue?vue&type=template&id=0780d823"
import script from "./EnrollView.vue?vue&type=script&lang=js"
export * from "./EnrollView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__